import { mapValues } from 'lodash'

type MapValues = typeof mapValues

export const objectMapValues: MapValues = mapValues
